import React, { useEffect } from 'react';
import { CONFIG } from '../../../config';
import './AmazonWalletWidget.scss';

type Props = {
  billingAgreementId?: string;
};

const CONTAINER_ID = 'amazonWalletWidget';

const renderWidget = (billingAgreementId?: string) => {
  new window.OffAmazonPayments.Widgets.Wallet({
    sellerId: CONFIG.AMAZON_SELLER_ID,
    amazonBillingAgreementId: billingAgreementId,
    design: {
      designMode: 'responsive'
    }
  }).bind(CONTAINER_ID);
};

export const AmazonWalletWidget: React.FC<Props> = ({ billingAgreementId }) => {
  useEffect(() => {
    renderWidget(billingAgreementId);
  }, [billingAgreementId]);

  return <div id={CONTAINER_ID} className="AmazonWalletWidget" />;
};
